import React, { PureComponent } from 'react';

import Avatar from '@justgiving/avatar';
import { IMemberCard } from './MemberCard.d';
import { Trans } from 'react-i18next';

export class MemberCard extends PureComponent<IMemberCard> {
  handleClick = () => {
    const { onClick, member } = this.props;
    onClick(member);
  };

  render() {
    const { member, isCaptain, canUnlinkMember } = this.props;
    const memberFullName = `${member.firstName} ${member.lastName}`;

    return (
      <li className="jg-space-pbms jg-tc-member-card">
        <a
          className="jg-display-flex"
          href={member.pageUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div>
            <Avatar
              avatarSize="large"
              picture={member.profileImage ? member.profileImage : ''}
            />
          </div>
          <div className="jg-space-mlms">
            <span className="jg-h5">{memberFullName}</span>

            <div className="jg-color--empress jg-text--medium-light jg-tc-frp-name">
              {member.fundraisingPageName}
            </div>
            {isCaptain && (
              <span className="jg-color--empress jg-text--medium-regular ">
                <Trans i18nKey="content.editmembers.teamCaptain" />
              </span>
            )}
          </div>
        </a>
        {canUnlinkMember && (
          <button
            onClick={this.handleClick}
            className="jg-text--link jg-btn--invisible jg-pull-right jg-tc-unlink-button"
            type="button"
            data-qa={`unlink-member-${member.fundraisingPageShortName}`}
          >
            <Trans i18nKey="content.editmembers.unlink" />
          </button>
        )}
      </li>
    );
  }
}

export default MemberCard;
